import { object, string } from "yup";
import { SHORT_FIELD_MESSAGE, REQUIRED_FIELD_MESSAGE, INVALID_FIELD_MESSAGE } from "../../../../Shared";

export const validationSchema = object({
  password:   string()
              .required(REQUIRED_FIELD_MESSAGE),
  passwordConfirmation:   string()
                          .required(REQUIRED_FIELD_MESSAGE),
});

